// Remember each category list's sort / facet / grouping choices across visits
// and app restarts (roadmap #21). `persistedState(key, defaults)` returns a
// plain-looking state object: reads come from it, and every assignment is also
// written to localStorage. Keys listed in `skip` (e.g. the device-wide gallery /
// list view, which has its own setting) are never stored.

const PREFIX = "list-prefs:";

export function persistedState(key, defaults, { skip = ["view"] } = {}) {
	let saved = {};
	try {
		saved = JSON.parse(localStorage.getItem(PREFIX + key) ?? "{}") ?? {};
	} catch {
		saved = {};
	}
	const initial = { ...defaults };
	for (const [k, v] of Object.entries(saved)) {
		// Only restore known keys of the same type (a stale or tampered value is ignored).
		if (k in defaults && !skip.includes(k) && typeof v === typeof defaults[k]) initial[k] = v;
	}
	const persist = (obj) => {
		try {
			const out = {};
			for (const [k, v] of Object.entries(obj)) if (!skip.includes(k)) out[k] = v;
			localStorage.setItem(PREFIX + key, JSON.stringify(out));
		} catch {
			// storage unavailable — the choice just isn't remembered
		}
	};
	return new Proxy(initial, {
		set(target, prop, value) {
			target[prop] = value;
			persist(target);
			return true;
		},
	});
}
